var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({staticClass:"px-4",attrs:{"color":_vm.color,"outlined":_vm.outlined},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', $event)}}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }